export default "__VITE_ASSET__zeKQmv6E__"